<sbnb-signup-user-header [isReturning]="true"></sbnb-signup-user-header>

<p>
  We have just sent a magic link to your email
  <span *ngIf="signupUserService.user$.value?.email" class="raspberry-darker">
    {{ signupUserService.user$.value?.email }}
  </span>
</p>

<p>Check your inbox and click the link in the mail to resume your registration</p>
